import { render } from "./AdminApproved75Liquidations.vue?vue&type=template&id=55e22c7c"
import script from "./AdminApproved75Liquidations.vue?vue&type=script&lang=js"
export * from "./AdminApproved75Liquidations.vue?vue&type=script&lang=js"

import "./AdminApproved75Liquidations.vue?vue&type=style&index=0&id=55e22c7c&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__